export default __webpack_public_path__ + "static/3-f2ea19f15b50ec5e7b8398af0e2eefa1.webp";